"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DialogResizeHandle: true
};
exports.default = exports.DialogResizeHandle = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _clamp = require("../utils/_clamp");
var _isFunction = require("../utils/isFunction");
var _Dialog = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Dialog.css") : void 0);
var _DialogResizeHandle = require("./_DialogResizeHandle.types");
Object.keys(_DialogResizeHandle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogResizeHandle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogResizeHandle[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable @typescript-eslint/ban-ts-comment */

const CSS_BLOCK = 'sapcnqr-dialog';
const RESIZE_STEP_SIZE = 16;
const DialogResizeHandle = exports.DialogResizeHandle = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      className,
      containerRef,
      handleLabel,
      height,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      width,
      onDragStart,
      onDragEnd,
      onKeyDown,
      updateSize
    } = props,
    otherProps = __rest(props, ["className", "containerRef", "handleLabel", "height", "maxHeight", "maxWidth", "minHeight", "minWidth", "width", "onDragStart", "onDragEnd", "onKeyDown", "updateSize"]);
  const classnames = _bind.default.bind(_Dialog.default);
  const modalRef = (0, _react.useRef)(null);
  const mergedRef = (0, _reactMergeRefs.default)([ref, modalRef]);
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({
    width: 0,
    height: 0,
    startWidth: 0,
    startX: 0,
    startHeight: 0,
    startY: 0
  });
  // @ts-expect-error
  const contentClientRect = () => {
    var _a;
    return (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  };
  const getContentTop = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.top) || 0;
  };
  const getContentBottom = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.bottom) || 0;
  };
  const getContentLeft = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.left) || 0;
  };
  const getContentRight = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.right) || 0;
  };
  const getDialogHeight = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.height) || 0;
  };
  const getDialogWidth = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.width) || 0;
  };
  const minResizableWidth = Math.max(minWidth || 0, 200);
  const maxResizableWidth = Math.min(maxWidth || 999999, 99999);
  const minResizableHeight = Math.max(minHeight || 0, 50);
  const maxResizableHeight = Math.min(maxHeight || 999999, 99999);
  const onMouseDown = (0, _react.useCallback)(e => {
    var _a;
    (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
    if (e.button !== 0) {
      return;
    }
    if ((0, _isFunction.isFunction)(onDragStart)) {
      onDragStart(e);
    }
    setIsDragging(true);
    setPosition(prevState => Object.assign(Object.assign({}, prevState), {
      startX: e.pageX,
      startY: e.clientY,
      startWidth: getDialogWidth(),
      startHeight: getDialogHeight()
    }));
  }, []);
  const handleOnKeyDown = e => {
    var _a;
    (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
    const resizeStepSize = e.shiftKey ? 5 * RESIZE_STEP_SIZE : RESIZE_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        {
          e.preventDefault();
          let reducedWidth = getDialogWidth() - resizeStepSize;
          reducedWidth = (0, _clamp.clamp)(reducedWidth, minResizableWidth, maxResizableWidth);
          updateSize === null || updateSize === void 0 ? void 0 : updateSize({
            width: `${reducedWidth}px`,
            height: `${getDialogHeight()}px`
          });
          setPosition(prevState => Object.assign(Object.assign({}, prevState), {
            width: reducedWidth
          }));
          break;
        }
      case _keycode.default.codes.right:
        {
          e.preventDefault();
          let increasedWidth = getDialogWidth() + Math.min(resizeStepSize, window.innerWidth - getContentRight());
          increasedWidth = (0, _clamp.clamp)(increasedWidth, minResizableWidth, maxResizableWidth);
          updateSize === null || updateSize === void 0 ? void 0 : updateSize({
            width: `${increasedWidth}px`,
            height: `${getDialogHeight()}px`
          });
          setPosition(prevState => Object.assign(Object.assign({}, prevState), {
            width: increasedWidth
          }));
          break;
        }
      case _keycode.default.codes.up:
        {
          e.preventDefault();
          let reducedHeight = getDialogHeight() - resizeStepSize;
          reducedHeight = (0, _clamp.clamp)(reducedHeight, minResizableHeight, maxResizableHeight);
          updateSize === null || updateSize === void 0 ? void 0 : updateSize({
            height: `${reducedHeight}px`,
            width: `${getDialogWidth()}px`
          });
          setPosition(prevState => Object.assign(Object.assign({}, prevState), {
            height: reducedHeight
          }));
          break;
        }
      case _keycode.default.codes.down:
        {
          e.preventDefault();
          let increasedHeight = getDialogHeight() + Math.min(resizeStepSize, window.innerHeight - getContentBottom());
          increasedHeight = (0, _clamp.clamp)(increasedHeight, minResizableHeight, maxResizableHeight);
          updateSize === null || updateSize === void 0 ? void 0 : updateSize({
            height: `${increasedHeight}px`,
            width: `${getDialogWidth()}px`
          });
          setPosition(prevState => Object.assign(Object.assign({}, prevState), {
            height: increasedHeight
          }));
          break;
        }
      default:
    }
    if ((0, _isFunction.isFunction)(onKeyDown)) {
      onKeyDown(e);
    }
  };
  (0, _react.useEffect)(() => {
    // update dialog size if resizable values change
    const newWidth = `${(0, _clamp.clamp)(width, minResizableWidth, maxResizableWidth)}px` || getDialogWidth();
    const newHeight = `${(0, _clamp.clamp)(height, minResizableHeight, maxResizableHeight)}px` || getDialogHeight();
    updateSize === null || updateSize === void 0 ? void 0 : updateSize({
      width: newWidth,
      height: newHeight
    });
  }, [width, height, minResizableWidth, maxResizableWidth, minResizableHeight, maxResizableHeight]);
  (0, _react.useEffect)(() => {
    const onMouseMove = e => {
      var _a;
      (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
      const x = e.pageX;
      const y = e.clientY;
      let newWidth = position.startWidth + (x - position.startX) * 2;
      const _maxWidth = Math.min(maxResizableWidth, window.innerWidth - getContentLeft());
      newWidth = (0, _clamp.clamp)(newWidth, minResizableWidth, _maxWidth);
      let newHeight = position.startHeight + (y - position.startY) * 2;
      const _maxHeight = Math.min(maxResizableHeight, window.innerHeight - getContentTop());
      newHeight = (0, _clamp.clamp)(newHeight, minResizableHeight, _maxHeight);
      updateSize === null || updateSize === void 0 ? void 0 : updateSize({
        height: `${newHeight}px`,
        width: `${newWidth}px`
      });
    };
    const onMouseUp = e => {
      var _a;
      (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
      setIsDragging(false);
      if ((0, _isFunction.isFunction)(onDragEnd)) {
        onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging, position]);
  const classes = classnames(`${CSS_BLOCK}__resize-handle`, className);
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({}, otherProps, {
    "aria-label": handleLabel,
    className: classes,
    ref: mergedRef,
    onMouseDown: onMouseDown,
    onKeyDown: handleOnKeyDown,
    role: "button",
    tabIndex: 0
  }));
});
DialogResizeHandle.displayName = 'DialogResizeHandle';
var _default = exports.default = DialogResizeHandle;